module.exports = __webpack_public_path__ + "img/Logo.707b3de3.png";